module.exports = __webpack_public_path__ + "img/4-1-north-4.47c5b727.jpg";